export const faqData = {
    categories: [
        {
            id: 'umum',
            title: 'Informasi Umum',
            icon: 'ℹ️',
            questions: [
                {
                    id: 1,
                    question: 'Apa itu BPKAD?',
                    answer: 'BPKAD (Badan Pengelolaan Keuangan dan Aset Daerah) adalah lembaga pemerintah daerah yang bertugas mengelola keuangan dan aset daerah secara profesional, akuntabel, dan transparan. BPKAD Kota Magelang bertanggung jawab dalam pengelolaan anggaran, pendapatan, perbendaharaan, akuntansi, dan aset daerah.'
                },
                {
                    id: 2,
                    question: 'Dimana lokasi kantor BPKAD Kota Magelang?',
                    answer: 'Kantor BPKAD Kota Magelang beralamat di Jl. Jend. Sudirman No. 10, Magelang, Jawa Tengah. Kantor buka setiap hari Senin-Kamis pukul 07.30-16.00 WIB dan Jumat pukul 07.30-16.30 WIB.'
                },
                {
                    id: 3,
                    question: 'Bagaimana cara menghubungi BPKAD?',
                    answer: 'Anda dapat menghubungi BPKAD melalui:\n- Telepon: (0293) 123456\n- Email: bpkad@magelangkota.go.id\n- Instagram: @bpkadmagelang\n- Website: bpkad.magelangkota.go.id\n- Kunjungan langsung ke kantor pada jam kerja'
                },
                {
                    id: 4,
                    question: 'Apa saja layanan yang tersedia di BPKAD?',
                    answer: 'BPKAD menyediakan berbagai layanan, antara lain:\n- Pembayaran retribusi IPT dan IPR\n- Perizinan pemakaian aset daerah\n- Sewa gedung dan bangunan\n- Sewa kendaraan dinas\n- Sewa mesin dan peralatan\n- Surat keterangan mandiri\n- Informasi status tanah\n- Konsultasi pengelolaan keuangan'
                },
                {
                    id: 5,
                    question: 'Apakah layanan BPKAD dipungut biaya?',
                    answer: 'Sebagian besar layanan administratif seperti pembuatan surat keterangan TIDAK dipungut biaya (GRATIS). Namun untuk layanan sewa aset dan retribusi dikenakan biaya sesuai dengan Peraturan Daerah yang berlaku.'
                }
            ]
        },
        {
            id: 'retribusi',
            title: 'Retribusi & Pembayaran',
            icon: '💰',
            questions: [
                {
                    id: 6,
                    question: 'Apa itu Retribusi IPT?',
                    answer: 'Retribusi Izin Pemakaian Tanah (IPT) adalah pembayaran atas pemberian izin pemakaian tanah milik Pemerintah Kota Magelang. Tarif dihitung berdasarkan luas tanah, zona lokasi, dan peruntukan penggunaan. Gunakan kalkulator retribusi di website kami untuk estimasi biaya.'
                },
                {
                    id: 7,
                    question: 'Apa itu Retribusi IPR?',
                    answer: 'Retribusi Izin Pemakaian Ruangan (IPR) adalah pembayaran atas pemberian izin pemakaian ruangan/gedung milik Pemerintah Kota Magelang. Tarif dihitung berdasarkan jenis ruangan, luas, zona, dan fasilitas yang digunakan.'
                },
                {
                    id: 8,
                    question: 'Bagaimana cara membayar retribusi?',
                    answer: 'Pembayaran retribusi dapat dilakukan melalui:\n1. Bank Jateng\n2. BNI\n3. BRI\n4. QRIS\n5. Mobile Banking\n\nSetelah mendapatkan SKRD (Surat Ketetapan Retribusi Daerah), Anda dapat membayar melalui channel tersebut dengan mencantumkan nomor SKRD.'
                },
                {
                    id: 9,
                    question: 'Apakah retribusi bisa dicicil?',
                    answer: 'Untuk nilai retribusi di atas Rp 10.000.000, dapat mengajukan permohonan pembayaran bertahap maksimal 3 kali angsuran dengan persetujuan Kepala BPKAD. Ajukan permohonan secara tertulis disertai alasan yang jelas.'
                },
                {
                    id: 10,
                    question: 'Bagaimana jika telat membayar retribusi?',
                    answer: 'Keterlambatan pembayaran retribusi dikenakan denda sebesar 2% per bulan dari nilai retribusi yang tertunggak. Jika melebihi 3 bulan, izin dapat dicabut dan dikenakan sanksi administratif.'
                },
                {
                    id: 11,
                    question: 'Apakah retribusi bisa dikembalikan?',
                    answer: 'Retribusi TIDAK dapat dikembalikan kecuali terdapat kesalahan administratif dari pihak BPKAD yang mengakibatkan kelebihan pembayaran. Dalam hal tersebut, kelebihan akan dikembalikan melalui mekanisme yang berlaku.'
                }
            ]
        },
        {
            id: 'perizinan',
            title: 'Perizinan Aset',
            icon: '📋',
            questions: [
                {
                    id: 12,
                    question: 'Bagaimana cara mengajukan izin pemakaian tanah?',
                    answer: 'Langkah mengajukan IPT:\n1. Siapkan dokumen persyaratan (KTP, proposal, site plan, dll)\n2. Isi formulir online di website atau datang ke kantor\n3. Upload dokumen pendukung\n4. Tunggu verifikasi (1-3 hari kerja)\n5. Survey lokasi oleh tim teknis\n6. Pembayaran retribusi\n7. Izin diterbitkan'
                },
                {
                    id: 13,
                    question: 'Berapa lama proses perizinan?',
                    answer: 'Estimasi waktu proses perizinan:\n- Verifikasi dokumen: 1-3 hari kerja\n- Survey lapangan: 3-7 hari kerja\n- Penerbitan SKRD: 2-3 hari kerja\n- Penerbitan izin: setelah pembayaran\n\nTotal: sekitar 14-21 hari kerja'
                },
                {
                    id: 14,
                    question: 'Dokumen apa saja yang diperlukan untuk mengajukan IPT?',
                    answer: 'Dokumen yang diperlukan:\n1. Fotokopi KTP pemohon\n2. NPWP (jika ada)\n3. Proposal rencana penggunaan tanah\n4. Gambar site plan/lokasi\n5. Surat rekomendasi kelurahan\n6. Surat pernyataan bermaterai\n7. Dokumen pendukung lainnya'
                },
                {
                    id: 15,
                    question: 'Apakah izin bisa diperpanjang?',
                    answer: 'Ya, izin pemakaian tanah/ruangan dapat diperpanjang. Ajukan permohonan perpanjangan minimal 1 bulan sebelum masa berlaku habis. Pemegang izin lama mendapat prioritas perpanjangan.'
                },
                {
                    id: 16,
                    question: 'Berapa lama masa berlaku izin?',
                    answer: 'Masa berlaku izin pemakaian tanah/ruangan:\n- IPT: 1-5 tahun (dapat diperpanjang)\n- IPR: 1-3 tahun (dapat diperpanjang)\n- Sewa gedung: sesuai perjanjian\n- Sewa kendaraan: per hari/minggu/bulan'
                }
            ]
        },
        {
            id: 'sewa',
            title: 'Sewa Aset',
            icon: '🏢',
            questions: [
                {
                    id: 17,
                    question: 'Bagaimana cara menyewa gedung milik Pemkot?',
                    answer: 'Cara menyewa gedung:\n1. Cek ketersediaan gedung di website\n2. Pilih gedung dan tanggal\n3. Isi formulir sewa online\n4. Upload dokumen persyaratan\n5. Tunggu konfirmasi ketersediaan\n6. Lakukan pembayaran DP 50%\n7. Serah terima kunci dan gunakan gedung'
                },
                {
                    id: 18,
                    question: 'Apa itu deposit sewa?',
                    answer: 'Deposit sewa adalah jaminan yang dibayarkan di awal masa sewa, biasanya sebesar 25-30% dari total biaya sewa. Deposit akan dikembalikan 100% saat masa sewa berakhir jika:\n- Tidak ada kerusakan\n- Tidak ada tunggakan\n- Semua fasilitas lengkap\n- Kebersihan terjaga'
                },
                {
                    id: 19,
                    question: 'Bisakah menyewa kendaraan dinas untuk keperluan pribadi?',
                    answer: 'Kendaraan dinas dapat disewa oleh masyarakat umum dengan ketentuan:\n- Tersedia opsi dengan atau tanpa supir\n- Untuk keperluan yang sah\n- Menyerahkan SIM dan STNK (jika tanpa supir)\n- Membayar deposit\n- Bertanggung jawab atas kerusakan'
                },
                {
                    id: 20,
                    question: 'Apakah ada diskon untuk sewa jangka panjang?',
                    answer: 'Ya, tersedia diskon untuk sewa jangka panjang:\n- Sewa 2 tahun: diskon 5%\n- Sewa 3 tahun: diskon 10%\n- Sewa 5 tahun: diskon 15%\n\nKhusus untuk UMKM lokal Kota Magelang mendapat tambahan diskon 5%.'
                },
                {
                    id: 21,
                    question: 'Bagaimana jika terjadi kerusakan saat menyewa?',
                    answer: 'Jika terjadi kerusakan:\n1. Kerusakan wajar (wear & tear): tanggung jawab BPKAD\n2. Kerusakan akibat kelalaian: biaya perbaikan diambil dari deposit\n3. Kerusakan berat: ditagihkan ke penyewa\n\nLaporkan segera kerusakan ke petugas BPKAD.'
                }
            ]
        },
        {
            id: 'surat',
            title: 'Surat Keterangan',
            icon: '📄',
            questions: [
                {
                    id: 22,
                    question: 'Jenis surat apa saja yang bisa dibuat?',
                    answer: 'BPKAD melayani pembuatan surat keterangan:\n1. Surat Keterangan Domisili\n2. Surat Keterangan Usaha\n3. Surat Keterangan Tidak Mampu\n4. Surat Keterangan Kehilangan\n\nSemua surat keterangan TIDAK DIPUNGUT BIAYA (GRATIS).'
                },
                {
                    id: 23,
                    question: 'Berapa lama proses pembuatan surat keterangan?',
                    answer: 'Estimasi waktu pembuatan surat:\n- Surat Domisili: 1-2 hari kerja\n- Surat Usaha: 2-3 hari kerja\n- Surat Tidak Mampu: 2-3 hari kerja\n- Surat Kehilangan: 1-2 hari kerja\n\nProses lebih cepat jika dokumen lengkap dan valid.'
                },
                {
                    id: 24,
                    question: 'Apakah bisa mengajukan surat secara online?',
                    answer: 'YA! Semua jenis surat keterangan dapat diajukan secara online melalui website BPKAD. Cukup isi formulir, upload dokumen, dan tunggu verifikasi. Surat jadi dapat diunduh dalam format PDF.'
                },
                {
                    id: 25,
                    question: 'Dokumen apa yang diperlukan untuk membuat surat keterangan?',
                    answer: 'Dokumen umum yang diperlukan:\n1. Fotokopi KTP\n2. Fotokopi Kartu Keluarga\n3. Surat pengantar RT/RW\n4. Pas foto 3x4 (2 lembar)\n5. Dokumen pendukung sesuai jenis surat\n\nUpload semua dokumen melalui website untuk proses lebih cepat.'
                }
            ]
        },
        {
            id: 'apbd',
            title: 'APBD & Keuangan',
            icon: '📊',
            questions: [
                {
                    id: 26,
                    question: 'Apa itu APBD?',
                    answer: 'APBD (Anggaran Pendapatan dan Belanja Daerah) adalah rencana keuangan tahunan pemerintah daerah yang disetujui oleh DPRD. APBD terdiri dari:\n- Pendapatan Daerah (PAD, dana perimbangan, dll)\n- Belanja Daerah (operasional, modal, dll)\n- Pembiayaan Daerah'
                },
                {
                    id: 27,
                    question: 'Kapan APBD ditetapkan?',
                    answer: 'APBD ditetapkan paling lambat:\n- 30 November untuk tahun anggaran berikutnya\n- Setelah melalui pembahasan dengan DPRD\n- Disetujui oleh Gubernur (untuk kabupaten/kota)\n\nAPBD Perubahan ditetapkan paling lambat 30 September.'
                },
                {
                    id: 28,
                    question: 'Bagaimana masyarakat bisa mengakses informasi APBD?',
                    answer: 'Informasi APBD dapat diakses melalui:\n1. Website BPKAD Kota Magelang\n2. Papan pengumuman di kantor BPKAD\n3. Portal PPID\n4. Media sosial resmi Pemkot Magelang\n5. Layanan informasi publik\n\nRingkasan APBD dipublikasikan untuk transparansi.'
                },
                {
                    id: 29,
                    question: 'Apa itu PAD dan apa saja sumbernya?',
                    answer: 'PAD (Pendapatan Asli Daerah) adalah pendapatan yang diperoleh dari sumber-sumber di dalam daerah. Sumber PAD meliputi:\n- Pajak Daerah (PBB, BPHTB, dll)\n- Retribusi Daerah (IPT, IPR, dll)\n- Hasil pengelolaan kekayaan daerah\n- Lain-lain PAD yang sah'
                }
            ]
        },
        {
            id: 'pengaduan',
            title: 'Pengaduan',
            icon: '🎧',
            questions: [
                {
                    id: 30,
                    question: 'Bagaimana cara menyampaikan pengaduan?',
                    answer: 'Saluran pengaduan yang tersedia:\n1. SP4N LAPOR! (www.lapor.go.id)\n2. Monggo Lapor (aplikasi mobile)\n3. WhatsApp: 0811-2600-170\n4. Email: aduan@magelangkota.go.id\n5. Telepon: (0293) 123456\n6. Kotak pengaduan di kantor BPKAD\n7. Datang langsung ke kantor'
                },
                {
                    id: 31,
                    question: 'Berapa lama pengaduan ditanggapi?',
                    answer: 'Waktu penanganan pengaduan:\n- Respon awal: maksimal 5 hari kerja\n- Penyelesaian: maksimal 14 hari kerja\n- Pengaduan kompleks: dapat diperpanjang\n\nStatus pengaduan dapat dipantau secara online.'
                },
                {
                    id: 32,
                    question: 'Apakah identitas pelapor dirahasiakan?',
                    answer: 'YA! Identitas pelapor DIJAMIN KERAHASIAANNYA sesuai dengan:\n- UU No. 14 Tahun 2008 tentang KIP\n- UU No. 25 Tahun 2009 tentang Pelayanan Publik\n- Peraturan terkait perlindungan whistleblower\n\nAnda juga bisa melapor secara anonim melalui kotak pengaduan.'
                },
                {
                    id: 33,
                    question: 'Apa yang terjadi setelah pengaduan disampaikan?',
                    answer: 'Proses penanganan pengaduan:\n1. Penerimaan dan pencatatan\n2. Verifikasi dan validasi\n3. Disposisi ke unit terkait\n4. Investigasi/tindak lanjut\n5. Penyelesaian\n6. Pelaporan hasil\n\nAnda akan mendapat notifikasi di setiap tahapan.'
                }
            ]
        },
        {
            id: 'teknis',
            title: 'Teknis & Lainnya',
            icon: '🔧',
            questions: [
                {
                    id: 34,
                    question: 'Apakah website BPKAD mobile friendly?',
                    answer: 'YA! Website BPKAD dirancang responsif dan dapat diakses melalui smartphone, tablet, maupun desktop. Semua fitur termasuk kalkulator retribusi, formulir online, dan tracking status dapat digunakan di perangkat mobile.'
                },
                {
                    id: 35,
                    question: 'Bagaimana cara mengecek status permohonan?',
                    answer: 'Anda dapat mengecek status permohonan melalui:\n1. Halaman "Cek Status" di masing-masing layanan\n2. Masukkan nomor registrasi\n3. Status akan ditampilkan secara real-time\n\nSimpan nomor registrasi yang diberikan saat mengajukan permohonan.'
                },
                {
                    id: 36,
                    question: 'Apakah data pribadi saya aman?',
                    answer: 'YA! BPKAD berkomitmen menjaga keamanan data pribadi dengan:\n- Enkripsi data (SSL/HTTPS)\n- Sistem keamanan berlapis\n- Akses terbatas petugas berwenang\n- Sesuai UU Perlindungan Data Pribadi\n- Tidak membagikan data ke pihak ketiga'
                },
                {
                    id: 37,
                    question: 'Bagaimana jika saya mengalami kesulitan menggunakan website?',
                    answer: 'Jika mengalami kesulitan:\n1. Hubungi helpdesk: (0293) 123456\n2. Email: support@magelangkota.go.id\n3. Kunjungi kantor untuk bantuan langsung\n4. Lihat panduan di halaman bantuan\n\nPetugas kami siap membantu Anda!'
                },
                {
                    id: 38,
                    question: 'Apakah ada layanan konsultasi tatap muka?',
                    answer: 'YA! BPKAD menyediakan layanan konsultasi tatap muka di kantor pada jam kerja. Anda juga dapat membuat janji konsultasi terlebih dahulu melalui telepon atau email untuk pelayanan yang lebih optimal.'
                }
            ]
        }
    ],
    popularQuestions: [1, 6, 12, 17, 26, 30]
};